import { NextPage } from "next";
import Head from "next/head";

// Types
import { getRankName } from "../types";

// State
import { useAppSelector } from "../app/hooks";
import {
  selectSignedInUserFullName,
  selectSignedInUserRank,
} from "../app/signedInUserSlice";

const HomePage: NextPage = () => {
  const rank = useAppSelector(selectSignedInUserRank);
  const fullName = useAppSelector(selectSignedInUserFullName);

  return (
    <>
      <Head>
        <title>SSH Key Signing</title>
      </Head>
      <div className="mt-5">
        <h1 className="fw-light mb-4">Welcome, {fullName}</h1>
        <h2 className="fw-light mb-3">
          Please choose one of the options from the menu.
        </h2>
        <h3 className="fw-light text-muted">
          Your privilege level is {getRankName(rank)}.
        </h3>
      </div>
    </>
  );
};

// noinspection JSUnusedGlobalSymbols
export default HomePage;
